export default __webpack_public_path__ + "static/media/celeb.4efc392e.png";